// extracted by mini-css-extract-plugin
export default {"stepsAccordion":"styles_stepsAccordion__wy-xg","tagIcon":"styles_tagIcon__sh2d6"};